import authOneBg from "../assets/images/auth-one-bg.jpg";
import "../assets/css/login.css";
import "../assets/css/root.css";
import { useNavigate } from "react-router-dom";
import { api } from "../App";
import { useState } from "react";

function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    // initialize form fields here
    username: "",
    password: "",
  });
  const handleChange = (e) => {
    // update form data on input change
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };
  function textToHex(text) {
    let hexString = "";
    for (let i = 0; i < text.length; i++) {
      const hexCode = text.charCodeAt(i).toString(16);
      hexString += hexCode;
    }
    return hexString;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.username.length === 0 || formData.password.length === 0) {
      alert("يجب إدخال البيانات كاملة");
    } else {
      try {
        let hexUsername = textToHex(formData.username);
        let hexPassword = textToHex(formData.password);
        for (let i = 0; i < 100; i++) {
          let response = await fetch(
            `${api}login.php?username=${hexUsername}&password=${hexPassword}`
          );
          let responseData = JSON.parse(await response.text());
          if (responseData.state === false) {
            alert("بيانات خاطئة");
            break;
          } 
          else if (responseData.state === true) {
            localStorage.setItem("username", hexUsername);
            localStorage.setItem("password", hexPassword);
            // Get Permissions
             let permissions_state = await getPermissions();
            if (permissions_state === "No permissions") {
                alert("لم يتم العثور علي صلاحيات للمسخدم");
                return;
            }
            else if (!permissions_state) {
                alert("برجاء المحاولة مرة أخري");
                return;
            }
            navigate("/welcome");
            break;
          }
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      } catch (error) {
        alert("حدث خطأ في الإتصال مع السيرفير");
      }
    }
  };
  async function getPermissions() {
    for (let i = 0; i < 100; i++) {
      let username = localStorage.getItem("username");
      if (username != null || username !== undefined) {
        try {
          console.log(`${api}permissions.php?name=${username}`);
          let response2 = await fetch(
            `${api}permissions.php?username=${username}`
          );
          let responseData2 = await response2.text();
          if (responseData2["state"] === false) {
            alert("لا يوجد صلاحيات للمستخدم.");
            return "No Permissions";
          } else {
            localStorage.setItem(
              "permissions",
              JSON.stringify(JSON.parse(responseData2))
            );
            return true;
          }
        } catch (e) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }
    }
    return false;
  }

  return (
    <>
      <div style={{ backgroundImage: `url(${authOneBg})` }} className="welcome">
        <h1 className="logo">Premium Admin & Dashboard </h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          className="wave"
        >
          <path
            fill="#ffffff"
            fill-opacity="1"
            d="M0,128L6.2,122.7C12.3,117,25,107,37,117.3C49.2,128,62,160,74,181.3C86.2,203,98,213,111,197.3C123.1,181,135,139,148,128C160,117,172,139,185,165.3C196.9,192,209,224,222,197.3C233.8,171,246,85,258,53.3C270.8,21,283,43,295,96C307.7,149,320,235,332,240C344.6,245,357,171,369,144C381.5,117,394,139,406,138.7C418.5,139,431,117,443,117.3C455.4,117,468,139,480,128C492.3,117,505,75,517,58.7C529.2,43,542,53,554,53.3C566.2,53,578,43,591,64C603.1,85,615,139,628,154.7C640,171,652,149,665,122.7C676.9,96,689,64,702,48C713.8,32,726,32,738,48C750.8,64,763,96,775,106.7C787.7,117,800,107,812,106.7C824.6,107,837,117,849,122.7C861.5,128,874,128,886,133.3C898.5,139,911,149,923,138.7C935.4,128,948,96,960,80C972.3,64,985,64,997,80C1009.2,96,1022,128,1034,149.3C1046.2,171,1058,181,1071,154.7C1083.1,128,1095,64,1108,74.7C1120,85,1132,171,1145,176C1156.9,181,1169,107,1182,112C1193.8,117,1206,203,1218,202.7C1230.8,203,1243,117,1255,90.7C1267.7,64,1280,96,1292,112C1304.6,128,1317,128,1329,133.3C1341.5,139,1354,149,1366,165.3C1378.5,181,1391,203,1403,176C1415.4,149,1428,75,1434,37.3L1440,0L1440,320L1433.8,320C1427.7,320,1415,320,1403,320C1390.8,320,1378,320,1366,320C1353.8,320,1342,320,1329,320C1316.9,320,1305,320,1292,320C1280,320,1268,320,1255,320C1243.1,320,1231,320,1218,320C1206.2,320,1194,320,1182,320C1169.2,320,1157,320,1145,320C1132.3,320,1120,320,1108,320C1095.4,320,1083,320,1071,320C1058.5,320,1046,320,1034,320C1021.5,320,1009,320,997,320C984.6,320,972,320,960,320C947.7,320,935,320,923,320C910.8,320,898,320,886,320C873.8,320,862,320,849,320C836.9,320,825,320,812,320C800,320,788,320,775,320C763.1,320,751,320,738,320C726.2,320,714,320,702,320C689.2,320,677,320,665,320C652.3,320,640,320,628,320C615.4,320,603,320,591,320C578.5,320,566,320,554,320C541.5,320,529,320,517,320C504.6,320,492,320,480,320C467.7,320,455,320,443,320C430.8,320,418,320,406,320C393.8,320,382,320,369,320C356.9,320,345,320,332,320C320,320,308,320,295,320C283.1,320,271,320,258,320C246.2,320,234,320,222,320C209.2,320,197,320,185,320C172.3,320,160,320,148,320C135.4,320,123,320,111,320C98.5,320,86,320,74,320C61.5,320,49,320,37,320C24.6,320,12,320,6,320L0,320Z"
          ></path>
        </svg>{" "}
        <div className="overlay"></div>
      </div>
      <form action="" onSubmit={handleSubmit}>
        <span className="welcome-message">أهلا بعودتك!</span>
        <label form="username">إسم المستخدم</label>
        <input
          name="username"
          id="username"
          onChange={handleChange}
          placeholder="إكتب إسم المستخدم هنا...."
        ></input>
        <label form="password">الرقم السري</label>
        <input
          name="password"
          id="password"
          onChange={handleChange}
          placeholder="إكتب الرقم السري  هنا...."
          type="password"
        ></input>
        <button type="submit">تسجيل دخول</button>
      </form>
    </>
  );
}

export default LoginPage;
